<template>
  <v-row>
    <v-col cols="12">
      <div class="slick-space-gutter--15 slickdot--20">
        <VueSlickCarousel v-bind="settings" class="rn-slick-activation slick-dotted rn-slick-dot mt--10">
          <!-- Start Single Blog  -->

          <div class="im_box mt--30" v-for="(item, i) in blogContent" :key="i">
            <div class="thumbnail">
              <router-link :to="item.path">
                <img class="w-100" :src="item.src" alt="Blog Images" />
              </router-link>
            </div>
            <div class="content">
              <div class="inner">
                <div class="content_heading">
                  <div class="category_list">
                    <router-link :to="item.path">{{
                      item.category
                    }}</router-link>
                  </div>
                  <h4 class="heading-title">
                    <router-link :to="item.path">{{
                      item.title
                    }}</router-link>
                  </h4>
                </div>
                <div class="content_footer">
                  <router-link :to="item.path" class="rn-btn btn-opacity">
                    Read More
                  </router-link>
                </div>
              </div>
              <router-link class="transparent_link" :to="item.path"></router-link>
            </div>
          </div>

          <!-- End Single Blog  -->
        </VueSlickCarousel>
      </div>
    </v-col>
  </v-row>
</template>

<script>
import VueSlickCarousel from "vue-slick-carousel";
export default {
  components: {
    VueSlickCarousel,
  },
  data() {
    return {
      blogContent: [
        {
          src: require("../../assets/images/blog/blog-03.jpg"),
          title: "Edit Matplotlib plots in illustrator",
          category: "Design",
          path: "/blog/edit-matplotlib-plots-in-illustrator",
        },
        {
          src: require("../../assets/images/blog/blog-04.jpg"),
          title: "列赦集（篇一）",
          category: "Literature",
          path: "/blog/lie-she-ji-1",
        },
        {
          src: require("../../assets/images/blog/blog-02.jpg"),
          title: "How to use VS Code in SLURM cluster",
          category: "Development",
          path: "/blog/how-to-use-vs-code-in-slurm-cluster",
        },
        {
          src: require("../../assets/images/blog/blog-05.jpg"),
          title: "《李献计历险记》乐评",
          category: "Music",
          path: "/blog/li-xian-ji-movie-music-review",
        },
        {
          src: require("../../assets/images/blog/blog-01.jpg"),
          title: "Proxy configuration for docker on MacOS",
          category: "Development",
          path: "/blog/proxy-configuration-for-docker-on-macos",
        },
      ],
      // for all works
      settings: {
        dots: true,
        infinite: true,
        slidesToShow: 3,
        slidesToScroll: 1,
        spaceBetween: 15,

        responsive: [
          {
            breakpoint: 890,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 1,
              infinite: true,
              dots: true,
            },
          },
          {
            breakpoint: 770,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
              infinite: true,
              dots: true,
            },
          },
          {
            breakpoint: 490,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              initialSlide: 1,
            },
          },
        ],
      },
    };
  },
};
</script>
